module.exports = __webpack_public_path__ + "static/media/art75.a8ac917d.jpg";